export default __webpack_public_path__ + "static/media/twitter-svgrepo-com2.22f2bfd5.svg";